import QuickFilterButton from '@/components/Commons/Navigation/QuickFilterButton'
import QuickFilterContainer from '@/components/Commons/Navigation/QuickFilterContainer'

import TransactionsTable from '../_components/_shared/TransactionsTable'
import { REVIEW_STATUS } from '@/constants/reviewStatus'
import { COMPANIES_WITH_SPECIFIC_FEATURES } from '../_constants/constants'
import { EXPENSE_TYPES, TRANSACTION_TYPE_CODES } from '@/modules/transactions/_constants/constants'
import _transactionFiltersHelperMixin from './_transactionFiltersHelperMixin'
const TransactionsFilterModal = () => import('../_components/_shared/TransactionsFilterModal')
const TransactionEditModal = () => import('../_components/_shared/TransactionsEditModal')
const TransactionReceiptsViewerModal = () => import('../_components/_shared/TransactionReceiptsViewerModal')

export default {
  components: {
    TransactionsTable,
    TransactionsFilterModal,
    TransactionEditModal,
    TransactionReceiptsViewerModal,
    QuickFilterButton,
    QuickFilterContainer
  },
  mixins: [_transactionFiltersHelperMixin],
  data () {
    return {
      searchModel: {
        'status.code': '',
        'budget.name': '',
        'card.user.firstName': '',
        'card.user.lastName': '',
        merchant: ''
      },
      showFilterModalFlag: false,
      transactionToEditId: 0,
      preloadReceiptId: 0,
      transactionToShowReceiptId: 0,
      showEditTransactionModalFlag: false,
      showDetailTransactionModalFlag: false,
      showDetailDietModalFlag: false,
      showDetailMileageModalFlag: false,
      showTransactionReceiptModalFlag: false,
      showConfirmDeleteTransactionModalFlag: false,
      showCreateExpenseModalFlag: false,
      showCreateMileageModalFlag: false,
      showCreateDietModalFlag: false,
      receiptsModalExpenseMode: false,
      reviewStatusFilterCount: 0,
      initializing: true,
      showConfirmRemoveQuickFilterModalFlag: false,
      filteredViewIdToRemove: 0,
      filteredViewIdToEdit: 0
    }
  },
  methods: {
    async initializeTransactions () {
      await this.$store.dispatch('TransactionsStore/clearTransactions')
      await this.$store.dispatch('FiltersStore/TransactionsStore/clearStore')
      if (!this.$route.name.includes('budget')) {
        await this.$store.dispatch('BudgetsStore/clearStore')
      }
      this.$store.dispatch('TransactionsStore/setExpenses', this.$route.path.includes('expenses'))
      this.initializing = true
      if (!this.$route.name.includes('cards') && !this.$route.name.includes('export_') && !this.$route.meta.users) {
        await this.fetchTransactions()
      } else if (this.$route.meta.users) {
        await this.fetchUserTransactions()
      }
      this.initializing = false
    },
    setCurrentSection (event) {
      this.$emit('changeSection', event)
    },

    handleSearchQuery (event) {
      Object.keys(this.searchModel).forEach(key => {
        this.searchModel[key] = event
        return this.searchModel
      })
    },
    showFilterModal () {
      this.closeModals()
      this.showFilterModalFlag = true
      this.filteredViewIdToEdit = 0
      this.filteredViewIdToRemove = 0
      this.transactionToEdit = 0
    },
    showEditionTransactionModal (event, modal) {
      if (modal === 'expense') {
        this.showCreateExpenseModal(event)
      } else if (modal === 'diet') {
        this.showDietModal(event)
      } else if (modal === 'mileage') {
        this.showCreateMileageModal(event)
      } else {
        this.showEditTransactionModal(event)
      }
    },
    showTransactionModal (transaction, modal) {
      if (((transaction.reviewStatus?.code === REVIEW_STATUS.AWAITING_REVIEW || transaction.reviewStatus?.code === REVIEW_STATUS.OFFICE_FLOW_REVISION) && !transaction.isCompleted) || this.$route.name === 'user_reimbursements' || this.$route.name === 'user_transactions' || this.$route.name === 'budgets_reimbursements' || this.$route.name === 'budgets_transactions' || this.$route.name === 'my_charged_transactions' || this.$route.name === 'my_authorizations_transactions' || this.$route.name === 'my_declined_transactions' || this.$route.name === 'my_pending_reimbursements' || this.$route.name === 'my_history_reimbursements') {
        this.showEditionTransactionModal(transaction.id, modal)
      } else if (modal === 'mileage') {
        this.showDetailMileageModal(transaction.id, modal)
      } else if (modal === 'diet') {
        this.showDetailDietModal(transaction.id, modal)
      } else {
        this.showDetailTransactionModal(transaction.id, modal)
      }
    },
    showEditTransactionModal (event) {
      this.transactionToEditId = event
      this.closeModals()
      this.showEditTransactionModalFlag = true
    },
    showDetailTransactionModal (event) {
      this.transactionToEditId = event
      this.closeModals()
      this.showDetailTransactionModalFlag = true
    },
    showDetailDietModal (event) {
      this.transactionToEditId = event
      this.closeModals()
      this.showDetailDietModalFlag = true
    },
    showDetailMileageModal (event) {
      this.transactionToEditId = event
      this.closeModals()
      this.showDetailMileageModalFlag = true
    },
    showReceiptModal (event) {
      this.transactionToShowReceiptId = event.transactionId
      this.preloadReceiptId = event.receiptId
      this.showTransactionReceiptModalFlag = true
      this.showAccountingClosureModalFlag = false
    },
    showConfirmDeleteTransactionModal (event) {
      this.showConfirmDeleteTransactionModalFlag = true
      this.transactionToEditId = event
    },
    showCreateExpenseModal (event) {
      if (typeof event === 'number') {
        this.transactionToEditId = event
      } else {
        this.transactionToEditId = 0
      }
      this.closeModals()
      this.showCreateExpenseModalFlag = true
    },
    showCreateReimbursementModal (event) {
      if (typeof event === 'number') {
        this.transactionToEditId = event
      } else {
        this.transactionToEditId = 0
      }
      this.closeModals()
      this.showCreateExpenseModalFlag = true
    },
    showCreateMileageModal (event) {
      if (typeof event === 'number') {
        this.transactionToEditId = event
      } else {
        this.transactionToEditId = 0
      }
      this.closeModals()
      this.showCreateMileageModalFlag = true
    },
    showDietModal (event) {
      if (typeof event === 'number') {
        this.transactionToEditId = event
      } else {
        this.transactionToEditId = 0
      }
      this.closeModals()
      this.showCreateDietModalFlag = true
    },
    handleCloseTransactionReceiptModal () {
      if (this.showTransactionReceiptModalFlag) {
        this.showTransactionReceiptModalFlag = false
      }
      if (this.showExpenseReceiptPreviewModalFlag) {
        this.showExpenseReceiptPreviewModalFlag = false
      }

      this.$store.dispatch('TransactionsStore/setReceiptModalIsOpen', false)
    },
    incrementReviewStatusFilterCounter () {
      this.reviewStatusFilterCount++
    },
    showExportModal () {
      this.showTransactionExportModalFlag = true
    },
    closeModals () {
      this.showAccountingClosureModalFlag = false
      this.showCreateDietModalFlag = false
      this.showEditTransactionModalFlag = false
      this.showDetailTransactionModalFlag = false
      this.showDetailDietModalFlag = false
      this.showDetailMileageModalFlag = false
      this.showDetailDietModalFlag = false
      this.showDetailMileageModalFlag = false
      this.showCreateMileageModalFlag = false
      this.showCreateExpenseModalFlag = false
      this.showFilterModalFlag = false
      this.showSendToReviewWithoutReceipt = false
      this.showConfirmDeleteTransactionModalFlag = false
    },

    showAccountingClosureModal () {
      this.closeModals()
      this.showAccountingClosureModalFlag = true
    },
    async deleteTransaction () {
      await this.$store.dispatch(
        'TransactionsStore/deleteTransaction',
        this.transactionToEditId
      )
      this.closeModals()
    },
    closeTransactionReviewBar () {
      this.$store.dispatch(
        'TransactionsStore/toggleTransactionReviewBarShown',
        false
      )
    },
    closeTransactionMissingInfoBar () {
      this.$store.dispatch(
        'TransactionsStore/toggleTransactionMissingInfoBarShown',
        false
      )
    },
    checkCurrentFilteredView (filteredViewId) {
      if (this.currentFilteredView) {
        return this.currentFilteredView.id === filteredViewId
      }
      return false
    },
    handleRemoveFilteredView (filteredViewId) {
      this.filteredViewIdToRemove = filteredViewId
      this.showConfirmRemoveQuickFilterModalFlag = true
    },
    handleEditFilteredView (filteredViewId) {
      this.filteredViewIdToEdit = filteredViewId
      this.showFilterModalFlag = true
    },
    removeFilteredView () {
      this.$store.dispatch('TransactionsStore/removeFilteredView', this.filteredViewIdToRemove)
      this.showFilterModalFlag = false
      this.resetFilters()
      this.$root.$emit('refreshQuickFilterContainer')
    },
    async fetchTransactionDashboard () {
      await this.$store.dispatch(
        'TransactionsStore/fetchTransactionDashboard',
        this.expenses
      )
    },
    async resetFilters () {
      this.$store.dispatch('TransactionsStore/resetFilters')
      await this.fetchTransactions({ force: true })
      this.fetchTransactionDashboard()
      try {
        this.$router.replace({ query: {} }).catch(() => { })
      } catch (error) {

      }
    },
    async setCurrentViewFilters (event) {
      this.closeModals()
      this.showFilterModalFlag = false
      if (event?.id === this.currentFilteredView?.id) {
        this.resetFilters()
      } else {
        // this.$store.dispatch('TransactionsStore/resetFilters')
        this.$store.dispatch('TransactionsStore/setCurrentFilteredView', event)
        this.$store.dispatch('TransactionsStore/setUserSelectedFiltersAmount', this._countFilters(event.filters))
        const currentSelectedViewIndex = this.$store.getters['TransactionsStore/filteredViews'].findIndex(el => el.id === event.id)
        this.$root.$emit('scrollToSelectedQuickFilter', currentSelectedViewIndex)
        this.fetchTransactionDashboard()
        this.putFiltersUrl(event.filters)
      }
    },
    putFiltersUrl (filters) {
      // delete filters['card.user.id']
      this.$router.replace({ query: { ...filters } }).catch(() => { })
    },

    removeHash () {
      if (window.location.hash === '#exportHistory') {
        window.location.hash = ''
      }
    },
    parseQueryParams () {
      let query = {}
      Object.keys(this.$route.query).forEach(key => {
        query[key] = this.$route.query[key]
        if (this.$route.query[key] === 'true') {
          query[key] = true
        } else if (this.$route.query[key] === 'false') {
          query[key] = false
        }
      })
      return query
    },
    async checkInitialModals () {
      if (this.$route.query && this.$route.query.open) {
        if (!this.currentTransaction.id) {
          await this.$store.dispatch(
            'TransactionsStore/fetchTransaction',
            this.$route.query.open
          )
        }
        if (this.currentTransaction.id && this.currentTransaction.type.code === TRANSACTION_TYPE_CODES.EXPENSE) {
          if (this.currentTransaction.expense.type === EXPENSE_TYPES.MILEAGE) {
            await this.showCreateMileageModal(this.currentTransaction.id)
          } else if (this.currentTransaction.expense.type === EXPENSE_TYPES.DIET) {
            await this.showDietModal(this.currentTransaction.id)
          } else {
            await this.showTransactionModal(this.currentTransaction, 'expense')
          }
        } else {
          await this.showTransactionModal(this.currentTransaction)
        }
        if (this.$route.query.media) {
          setTimeout(() => {
            this.showReceiptModal({ transactionId: this.currentTransaction.id, receiptId: this.$route.query.mediaId })
          }, 500)
        }
      }
    }
  },
  computed: {
    isUser () {
      return this.$store.getters['LoginStore/isUser']
    },
    isAdmin () {
      return this.$store.getters['LoginStore/isAdmin']
    },
    isSuperBook () {
      return this.$store.getters['LoginStore/isSuperBookKeeper']
    },
    isCommercial () {
      return this.$store.getters['LoginStore/isCommercial']
    },
    columns () {
      if (this.tableName === 'history_users') {
        return this.$store.getters['TransactionsStore/tableUsersColumns'].filter(item => item.key !== 'select')
      } else if (this.tableName === 'transactionsExport') {
        return this.$store.getters['TransactionsStore/tableExportColumns'].filter(item => item.table ? item.table.includes(this.tableName) : item)
      } else if (this.tableName !== 'users') {
        return this.$store.getters['TransactionsStore/tableColumns'].filter(item => item.table ? item.table.includes(this.tableName) : item)
      } else {
        return this.$store.getters['TransactionsStore/tableUsersColumns']
      }
    },
    loggedUserId () {
      return this.$store.getters['LoginStore/loggedUserId']
    },
    transactionsFilters () {
      return this.$store.getters['TransactionsStore/filters']
    },
    filtersAmount () {
      return this.$store.getters['TransactionsStore/userSelectedFiltersAmount']
    },
    myExpensesRouteNames () {
      return ['my_pending_reimbursements', 'my_history_reimbursements', 'my_charged_transactions', 'my_authorizations_transactions', 'my_declined_transactions']
    },
    budgets () {
      return this.$store.getters['UsersStore/userBudgets'] || []
    },
    transactionReviewBarIsShown () {
      return this.$store.getters['TransactionsStore/transactionReviewBarIsShown']
    },
    transactionMissingInfoBarIsShown () {
      return this.$store.getters['TransactionsStore/transactionMissingInfoBarIsShown']
    },
    isInTransactionsAuthorizations () {
      return this.$route.name === 'transactions_authorizations'
    },
    isInDeclinedTransactions () {
      return this.$route.name === 'transactions_declined'
    },
    showTransactionSelect () {
      if (window.matchMedia('(max-width:576px)').matches) {
        return false
      }
      if (this.expenses) {
        return false
      }
      if (
        this.isInDeclinedTransactions ||
        this.isInTransactionsAuthorizations
      ) {
        return false
      }
      return true
    },
    userIsOwnerOfAnyBudget () {
      return this.$store.getters['LoginStore/isOwnerOfAnyBudget']
    },
    userIsReviewer () {
      return this.$store.getters['LoginStore/isReviewer']
    },
    transactionDataDashboard () {
      return this.$store.getters['TransactionsStore/transactionDashboard']
    },
    transactionsNotReviewed () {
      return this.transactionDataDashboard &&
        this.transactionDataDashboard.notReviewed
        ? this.transactionDataDashboard.notReviewed
        : 0
    },
    transactionsNotCompleted () {
      return this.transactionDataDashboard &&
        this.transactionDataDashboard.notCompleted
        ? this.transactionDataDashboard.notCompleted
        : 0
    },
    filteredViews () {
      if (this.isTwentyFourSeven) {
        return this.$store.getters['TransactionsStore/filteredViews']
      }
      return this.$store.getters['TransactionsStore/filteredViews'].filter(el => el.section === this.$route.meta.quickFilterSection)
    },
    currentFilteredView () {
      return this.$store.getters['TransactionsStore/currentFilteredView'] || false
    },
    /// IMPORTANTE, NO BORRAR!!!!!
    isPlexus () {
      let { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'PLEXUS')
      return this.$store.getters['CompanyStore/currentCompany'].id === id
    },
    isTwentyFourSeven () {
      let { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'TWENTYFOUR_SEVEN')
      return this.$store.getters['CompanyStore/currentCompany'].id === id
    },
    currentTransaction () {
      return this.$store.getters['TransactionsStore/currentTransaction'] || {}
    }
  },
  mounted () {
    if (window.location.hash === '#exportHistory') {
      setTimeout(() => {
        this.showTransactionExportModalFlag = true
        this.defaultExportTab = 'HISTORY'
      }, 1500)
    }
    this.checkInitialModals()
  },
  async created () {
    await this.initializeTransactions()
  },
  beforeRouteLeave (to, from, next) {
    if (this.currentFilteredView) {
      this.$store.dispatch('TransactionsStore/resetCurrentFilteredView')
    }
    next()
  }
}
